import EventEmitter from "eventemitter3";

import { createEventHook } from "@animus/react-utils";

import type { AuthEmitter, AuthEvents } from "./types";

export function createAuthEmitter(): AuthEmitter {
  return new EventEmitter<AuthEvents>();
}

// Needs a getter function to avoid circular imports
export function createUseAuthEvent(useAuthEmitter: () => AuthEmitter) {
  return createEventHook<AuthEvents>(useAuthEmitter);
}
